export type VehicleAlertType = "insurance" | "inspection" | "service" | "maintenance";
export type VehicleAlertLevel = "expired" | "very_soon" | "soon";

/** Eski bildirim mesajlarindaki teknik tarih parantezlerini temizler. */
export function sanitizeVehicleNotificationMessage(message: string | null | undefined): string {
  if (!message) return "";
  const text = message
    .replace(/\s*\(bitis:\s*(?:[^()]+|\([^)]*\))*\)\.?/gi, "")
    .replace(/\s*\(tarih:\s*(?:[^()]+|\([^)]*\))*\)\.?/gi, "")
    .replace(/\s{2,}/g, " ")
    .trim();
  if (!text) return "";
  return /[.!?]$/.test(text) ? text : `${text}.`;
}

export function vehicleAlertHeading(
  alertType: VehicleAlertType,
  alertLevel: VehicleAlertLevel,
): string {
  if (alertType === "insurance") {
    if (alertLevel === "expired") return "Sigorta Süresi Doldu";
    if (alertLevel === "very_soon") return "Sigorta Süresi Bitmek Üzere";
    return "Sigorta Süresi Yaklaşıyor";
  }
  if (alertType === "inspection") {
    if (alertLevel === "expired") return "Muayene Süresi Doldu";
    if (alertLevel === "very_soon") return "Muayene Günü Yaklaştı";
    return "Muayene Günü Yaklaşıyor";
  }
  if (alertType === "maintenance") {
    if (alertLevel === "expired") return "Planlı Bakım Tarihi Geçti";
    if (alertLevel === "very_soon") return "Araç Bakımı Yaklaştı";
    return "Araç Bakımı Yaklaşıyor";
  }
  if (alertLevel === "expired") return "Servis Kilometresi Aşıldı";
  if (alertLevel === "very_soon") return "Servis Bakımı Yaklaştı";
  return "Servis Bakımı Yaklaşıyor";
}

const NOTIFICATION_TYPE_HEADINGS: Record<string, string> = {
  vehicle_insurance_expired: "Sigorta Süresi Doldu",
  vehicle_insurance_very_soon: "Sigorta Süresi Bitmek Üzere",
  vehicle_insurance_soon: "Sigorta Süresi Yaklaşıyor",
  vehicle_inspection_expired: "Muayene Süresi Doldu",
  vehicle_inspection_very_soon: "Muayene Günü Yaklaştı",
  vehicle_inspection_soon: "Muayene Günü Yaklaşıyor",
  vehicle_maintenance_expired: "Planlı Bakım Tarihi Geçti",
  vehicle_maintenance_very_soon: "Araç Bakımı Yaklaştı",
  vehicle_maintenance_soon: "Araç Bakımı Yaklaşıyor",
  vehicle_service_expired: "Servis Kilometresi Aşıldı",
  vehicle_service_very_soon: "Servis Bakımı Yaklaştı",
  vehicle_service_soon: "Servis Bakımı Yaklaşıyor",
};

export function notificationTypeToHeading(type: string): string | null {
  return NOTIFICATION_TYPE_HEADINGS[type] ?? null;
}

export function parseVehicleNotificationTitle(title: string): { plate: string; heading: string } {
  const parts = title.split(/\s+[·—–-]\s+/);
  if (parts.length >= 2) {
    return { plate: parts[0].trim(), heading: parts.slice(1).join(" — ").trim() };
  }
  return { plate: title.trim(), heading: "" };
}
